export default __webpack_public_path__ + "static/media/plus22.1e76c9c5.jpg";